/* MORÉVA — world layer: cover, progress, cursor, ghosts, wipes, menu, veil, risings, palace atmosphere */
(function(){
  var doc=document;
  var reduced=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine=window.matchMedia&&matchMedia('(pointer: fine)').matches;

  /* — the cover: the reader opens the house (campaign traffic goes straight in) — */
  var camp=/[?&](utm_|gclid|fbclid|ttclid|msclkid)/.test(location.search);
  try{
    if(camp){sessionStorage.setItem('mvIntro','1');}
    if(!reduced&&!camp&&!sessionStorage.getItem('mvIntro')){
      sessionStorage.setItem('mvIntro','1');
      var coarse=window.matchMedia&&matchMedia('(pointer: coarse)').matches;
      var o=doc.createElement('div');o.className='mv-intro';o.setAttribute('aria-hidden','true');
      o.innerHTML='<div class="mv-i-frame"></div>'
        +'<span class="mv-i-est">Maison Moréva · Est. MMXXVI</span>'
        +'<span class="mv-i-word">MORÉVA</span>'
        +'<span class="mv-i-rule"></span>'
        +'<span class="mv-i-sub">Vol. I — The Angel Numbers</span>'
        +'<div class="mv-i-seal"><svg viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg"><defs><path id="mvSealIntro" d="M60,60 m-45,0 a45,45 0 1,1 90,0 a45,45 0 1,1 -90,0"/></defs><circle cx="60" cy="60" r="58" fill="none" stroke="currentColor" stroke-width="1" opacity=".5"/><circle cx="60" cy="60" r="33" fill="none" stroke="currentColor" stroke-width="1" opacity=".5"/><text><textPath href="#mvSealIntro">MAISON MORÉVA · EST. MMXXVI · IN NUMBERS ·</textPath></text></svg><span class="mv-i-sealcore">N°</span></div>'
        +'<div class="mv-i-cue"><span class="mv-i-cueline"></span><span class="mv-i-cuetext">'+(coarse?'Swipe up to enter':'Scroll to enter')+'</span></div>';
      doc.documentElement.classList.add('mv-intro-on');
      doc.body.appendChild(o);
      doc.body.style.overflow='hidden';
      var done=false,sy=null,dy=0,acc=0;
      var lift=function(){
        if(done)return;done=true;
        o.style.transition='transform .9s cubic-bezier(.76,0,.24,1)';
        o.style.transform='translateY(-104%)';
        doc.documentElement.classList.remove('mv-intro-on');
        doc.body.style.overflow='';
        setTimeout(function(){if(o.parentNode)o.parentNode.removeChild(o);},960);
      };
      o.addEventListener('wheel',function(e){e.preventDefault();acc+=e.deltaY;if(acc>50)lift();},{passive:false});
      o.addEventListener('touchstart',function(e){if(done)return;sy=e.touches[0].clientY;dy=0;o.style.transition='none';},{passive:true});
      o.addEventListener('touchmove',function(e){if(done||sy===null)return;dy=sy-e.touches[0].clientY;if(dy>0){e.preventDefault();o.style.transform='translateY('+(-dy)+'px)';}},{passive:false});
      o.addEventListener('touchend',function(){if(done||sy===null)return;if(dy>80){lift();}else{o.style.transition='transform .5s cubic-bezier(.22,.61,.36,1)';o.style.transform='translateY(0)';}sy=null;dy=0;});
      o.addEventListener('click',function(){lift();});
      doc.addEventListener('keydown',function(e){if(done)return;if(e.key==='Enter'||e.key===' '||e.key==='ArrowDown'||e.key==='PageDown'||e.key==='Escape')lift();});
    }
  }catch(e){}

  /* — palace light drifting through the rooms — */
  if(!reduced){
    var L=doc.createElement('div');L.className='mv-light';L.setAttribute('aria-hidden','true');doc.body.appendChild(L);
  }

  /* — dust motes rising in the hero light — */
  var hm=doc.querySelector('.hero-media');
  if(hm&&!reduced){
    var mo=doc.createElement('div');mo.className='mv-motes';mo.setAttribute('aria-hidden','true');
    var mh='';for(var mi=0;mi<9;mi++){mh+='<span></span>';}
    mo.innerHTML=mh;hm.appendChild(mo);
  }

  /* — gold reading progress — */
  var pr=doc.querySelector('.mv-progress i');
  if(pr){
    var pt=false;
    var pup=function(){var h=doc.documentElement;var max=h.scrollHeight-window.innerHeight;var p=max>0?Math.min(1,Math.max(0,window.scrollY/max)):0;pr.style.transform='scaleX('+p+')';pt=false;};
    window.addEventListener('scroll',function(){if(!pt){pt=true;requestAnimationFrame(pup);}},{passive:true});
    pup();
  }

  /* — cursor halo + gold dust trail — */
  if(!reduced&&fine){
    var c=doc.createElement('div');c.className='mv-cursor';c.setAttribute('aria-hidden','true');doc.body.appendChild(c);
    var x=0,y=0,tx=0,ty=0,seen=false;
    var pool=[],pi=0,lastD=0;
    for(var di=0;di<22;di++){var dp=doc.createElement('span');dp.className='mv-dustp';dp.setAttribute('aria-hidden','true');doc.body.appendChild(dp);pool.push(dp);}
    doc.addEventListener('mousemove',function(e){
      tx=e.clientX;ty=e.clientY;
      if(!seen){seen=true;x=tx;y=ty;c.style.opacity='.75';}
      var n=Date.now();
      if(n-lastD>55){lastD=n;var d=pool[pi++%pool.length];d.style.left=tx+'px';d.style.top=ty+'px';d.classList.remove('live');void d.offsetWidth;d.classList.add('live');}
    },{passive:true});
    doc.addEventListener('mouseover',function(e){var t=e.target;var hit=t.closest&&t.closest('a,button,summary,input,select,textarea,[role="button"]');c.classList.toggle('is-link',!!hit);});
    doc.addEventListener('mouseleave',function(){c.style.opacity='0';seen=false;});
    (function loop(){x+=(tx-x)*.16;y+=(ty-y)*.16;c.style.transform='translate('+x+'px,'+y+'px) translate(-50%,-50%)';requestAnimationFrame(loop);})();
  }

  /* — gilded tilt & sheen on imagery — */
  if(!reduced&&fine){
    Array.prototype.slice.call(doc.querySelectorAll('.card-media,.pdp-main,.split-media')).forEach(function(el){
      el.classList.add('mv-tilt');
      el.addEventListener('pointermove',function(e){
        var r=el.getBoundingClientRect();if(!r.width||!r.height)return;
        var px=(e.clientX-r.left)/r.width,py=(e.clientY-r.top)/r.height;
        el.style.setProperty('--mx',(px*100).toFixed(1)+'%');
        el.style.setProperty('--my',(py*100).toFixed(1)+'%');
        el.style.transform='perspective(900px) rotateX('+((.5-py)*2.6).toFixed(2)+'deg) rotateY('+((px-.5)*2.6).toFixed(2)+'deg)';
      });
      el.addEventListener('pointerleave',function(){el.style.transform='';});
    });
  }

  /* — ghost numerals drift — */
  var ghosts=Array.prototype.slice.call(doc.querySelectorAll('.mv-ghost'));
  if(ghosts.length&&!reduced){
    var gt=false;
    var gup=function(){
      ghosts.forEach(function(g){
        var host=g.parentElement;if(!host)return;
        var r=host.getBoundingClientRect();
        var sp=parseFloat(g.getAttribute('data-speed')||'0.1');
        var off=(r.top+r.height/2-window.innerHeight/2)*sp;
        g.style.transform='translateY('+off.toFixed(1)+'px)';
      });gt=false;};
    window.addEventListener('scroll',function(){if(!gt){gt=true;requestAnimationFrame(gup);}},{passive:true});
    gup();
  }

  /* — curtain wipes — */
  if('IntersectionObserver' in window&&!reduced){
    var els=Array.prototype.slice.call(doc.querySelectorAll('.split-media,.story-figure'));
    if(els.length){
      var wio=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('mv-in');wio.unobserve(e.target);}});},{threshold:.18});
      els.forEach(function(el){el.classList.remove('reveal','in','d1');el.classList.add('mv-wipe');wio.observe(el);});
    }
  }

  /* — risings: headings, folios, developing photographs — */
  if('IntersectionObserver' in window&&!reduced){
    var rio=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('mv-in');rio.unobserve(e.target);}});},{threshold:.12,rootMargin:'0px 0px -6% 0px'});
    Array.prototype.slice.call(doc.querySelectorAll('.section h2,.page-head h1,.mv-soon-title,.cart-h1')).forEach(function(h){h.classList.add('mv-h');rio.observe(h);});
    Array.prototype.slice.call(doc.querySelectorAll('.mv-folio')).forEach(function(f){f.classList.add('mv-anim');rio.observe(f);});
    Array.prototype.slice.call(doc.querySelectorAll('.card-media img,.split-media img,.story-figure img,.pdp-main img')).forEach(function(im){im.classList.add('mv-old');rio.observe(im);});
  }

  /* — the shop menu: two houses — */
  var shopItem=doc.querySelector('.nav-item.has-menu');
  if(shopItem){
    var sbtn=shopItem.querySelector('.nav-shop'),hideT;
    var sOpen=function(){clearTimeout(hideT);shopItem.classList.add('open');if(sbtn)sbtn.setAttribute('aria-expanded','true');};
    var sClose=function(){hideT=setTimeout(function(){shopItem.classList.remove('open');if(sbtn)sbtn.setAttribute('aria-expanded','false');},160);};
    shopItem.addEventListener('mouseenter',sOpen);
    shopItem.addEventListener('mouseleave',sClose);
    shopItem.addEventListener('focusin',sOpen);
    shopItem.addEventListener('focusout',function(){setTimeout(function(){if(!shopItem.contains(doc.activeElement)){shopItem.classList.remove('open');if(sbtn)sbtn.setAttribute('aria-expanded','false');}},10);});
    if(sbtn){sbtn.addEventListener('click',function(e){
      if(!shopItem.classList.contains('open')){e.preventDefault();sOpen();}
    });}
    doc.addEventListener('click',function(e){if(!shopItem.contains(e.target)){shopItem.classList.remove('open');if(sbtn)sbtn.setAttribute('aria-expanded','false');}});
    doc.addEventListener('keydown',function(e){if(e.key==='Escape'){shopItem.classList.remove('open');if(sbtn)sbtn.setAttribute('aria-expanded','false');}});
  }

  /* — the page turn: ink veil between rooms — */
  if(!reduced){
    doc.addEventListener('click',function(e){
      if(e.defaultPrevented||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
      var a=e.target.closest&&e.target.closest('a[href]');if(!a)return;
      if(a.target==='_blank'||a.hasAttribute('download'))return;
      var href=a.getAttribute('href')||'';
      if(!href||href.charAt(0)==='#'||href.indexOf('mailto:')===0||href.indexOf('tel:')===0||href.indexOf('javascript:')===0)return;
      var url;try{url=new URL(a.href,location.href);}catch(err){return;}
      if(url.origin!==location.origin)return;
      if(url.pathname===location.pathname&&url.hash)return;
      if(url.pathname.indexOf('/checkout')===0)return;
      e.preventDefault();
      var v=doc.querySelector('.mv-veil');
      if(!v){
        v=doc.createElement('div');v.className='mv-veil';v.setAttribute('aria-hidden','true');
        v.innerHTML='<span class="mv-veil-mono">N°</span><span class="mv-veil-word">MORÉVA</span>';
        doc.body.appendChild(v);
      }
      requestAnimationFrame(function(){requestAnimationFrame(function(){v.classList.add('up');});});
      setTimeout(function(){location.href=url.href;},580);
    });
    window.addEventListener('pageshow',function(){var v=doc.querySelector('.mv-veil');if(v&&v.parentNode)v.parentNode.removeChild(v);});
  }
})();